<script>
import HorizontalStackedBarChart from "@/shared/charts/horizontal-stacked-bar-chart/horizontal-stacked-bar-chart.vue";
import {colorMap} from "@/components/modules/new-dashboard/components/organizations-by-region/shared";

export default {
  name: "OrganizationsByRegionLabels",
  computed: {
    colorMap() {
      return colorMap;
    }
  },
  components: {},
  props: {
    chartData: {
      type: Array,
      required: true,
    },
    colors: {
      type: Array,
      required: true,
    },
    onSelectRegion: {
      type: Function,
      required: true,
    },
  },
};
</script>

<template>
  <div v-if="chartData" class="region-labels-container">
    <template v-for="(region, index) of chartData">
      <div class="region-label-container">
        <div
          class="region-label-name"
          @click="
            (e) => {
              e.stopPropagation();
              onSelectRegion(region.id);
            }
          "
        >
          {{ region.name }}
        </div>
        <div
          class="region-label-color"
          :style="{
            backgroundColor: colorMap[region.originalName] || colors[index],
          }"
          @click="onSelectRegion(region.id)"
        />
        <div class="region-label-value" @click="onSelectRegion(region.id)">
          {{ region.value }} ({{ region.percentage }}%)
        </div>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.region-labels {
  &-container {
    display: flex;
    gap: 10px;
    justify-content: center;
    place-self: center;
    flex-direction: column;
    height: 230px;
    flex-wrap: wrap;
    align-items: baseline;

    .region-label {
      &-container {
        display: flex;
        align-items: center;
        gap: 10px;
      }

      &-name {
        text-align: right;
        font-size: 12px;
        font-family: Montserrat, sans-serif;
        color: #4f4e4e;
        min-width: 115px;
        max-width: 115px;
        flex-grow: 0;
        flex-shrink: 0;
        flex-basis: 115px;
      }

      &-value {
        font-size: 16px;
        font-family: Montserrat, sans-serif;
        color: #2f60a6;
        opacity: 1;
        white-space: nowrap;
      }

      &-color {
        height: 12px;
        width: 12px;
        flex-shrink: 0;
      }
    }
  }
}
</style>
